import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/careers-page-view'

export const getStaticPaths = Page.getStaticPaths
export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.PageProps>()(Page.CareersPageView)
